import styled from 'styled-components';
import { Box, FileInput, Image } from 'uisos';

export const Avatar = styled(FileInput)`
  border-radius: 100%;
`;
